<template>
  <div class="perfil">
    <Button layout="back" @click="router.back()" class="show-s">
      <i class="fa fa-arrow-left"></i> Voltar
    </Button>
    <div class="content" v-if="!loader">
      <div class="row">
        <div class="title grid-8">Meus Dados</div>
        <div class="row grid-4 justify-end">
          <!--  <Button layout="green-go">Editar dados</Button> -->
        </div>
      </div>
      <div class="column section">
        <div class="sub">DADOS PESSOAIS</div>
        <div class="row column-s">
          <div class="grid-3 label column">
            <label>Seu nome</label>
            <div>{{ perfil.nome }}</div>
          </div>
          <div class="grid-3 label column">
            <label>Seu CPF</label>
            <div>{{ perfil.cpf }}</div>
          </div>
          <div class="grid-3 label column">
            <label>Seu E-mail</label>
            <div>{{ perfil.email }}</div>
          </div>
        </div>
      </div>
      <div class="divider"></div>
      <div class="column section">
        <div class="sub">SEU ENDEREÇO</div>
        <div class="row wrap">
          <div class="grid label column">
            <label>Logradouro</label>
            <div>{{ perfil.logradouro }}</div>
          </div>
          <div class="grid label column">
            <label>Número</label>
            <div>{{ perfil.numero }}</div>
          </div>
          <div class="grid label column">
            <label>Complemento</label>
            <div>{{ perfil.complemento }}</div>
          </div>
          <div class="grid label column">
            <label>Bairro</label>
            <div>{{ perfil.bairro }}</div>
          </div>
          <div class="grid label column">
            <label>Cidade</label>
            <div>{{ perfil.cidade }}</div>
          </div>
          <div class="grid label column">
            <label>Estado</label>
            <div>{{ perfil.estado }}</div>
          </div>
          <div class="grid label column">
            <label>CEP</label>
            <div>{{ perfil.cep }}</div>
          </div>
        </div>
      </div>
      <div class="divider"></div>
      <div class="column section">
        <div class="sub">DADOS CONTRATUAIS</div>
        <div class="row column-s">
          <div class="grid-4 label column">
            <label>Seu plano</label>
            <div>{{ perfil.plano || "" }}</div>
          </div>
        </div>
      </div>
      <Button class="hide-s" layout="white-m-gray" @click="router.back()">
        <i class="fa fa-arrow-left"></i> Voltar
      </Button>
    </div>
    <Loader v-else />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Button from "@/components/Button.vue";
import Loader from "@/components/Loader";
import Router from "@/router";

export default {
  name: "perfil",
  components: { Button, Loader },
  data() {
    return { loader: true, router: Router };
  },
  methods: {
    ...mapActions("user", ["LOAD_PERFIL"]),
  },
  computed: {
    ...mapGetters("user", ["perfil"]),
  },
  mounted() {
    this.LOAD_PERFIL().then(() => (this.loader = false));
  },
};
</script>


<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.perfil {
  .content {
    padding: 0px 35px;
    margin-top: 20px;
    background: #fff;
    .title {
      font-size: 32px;
      font-weight: 600;
      margin-bottom: 20px;
    }

    .sub {
      font-weight: 600;
      font-size: 14px;
      margin-bottom: 23px;
      margin-top: 35px;
    }

    .label {
      color: $gray-6;
      font-size: 14px;
      font-weight: 300;
      margin-bottom: 25px;
      div {
        color: $gray-7;
        font-size: 15px;
        font-weight: 500;
        text-transform: capitalize;
      }
    }
    .section {
      padding-bottom: 40px;
    }
  }
  .loader {
    left: 50%;
    margin-left: -45px;
    margin-top: 25%;
  }
  @media (max-width: $small) {
    padding: 7px;
  }
}
</style>
